import Loader from 'umg-ember-backend/components/ui/loader';

<template><Loader @isWaiting={{true}} /></template>
